import { render, staticRenderFns } from "./BotClients.vue?vue&type=template&id=1985ce03&"
import script from "./BotClients.vue?vue&type=script&lang=js&"
export * from "./BotClients.vue?vue&type=script&lang=js&"
import style0 from "./BotClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports